import React, {useState} from "react";
import {FormTab, Show, TextInput, TabbedForm, TopToolbar, NumberInput, EditButton, usePermissions} from 'react-admin';
import {makeStyles} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    unidad_medida: {display: 'inline-block', width: 200, marginLeft: 8},
    unidad_medida_d: {display: 'inline-block', width: 600, marginLeft: 108},
    unidad_medida_abre: {display: 'inline-block', width: 200, marginLeft: 8},
    codigo_afip: {display: 'inline-block', width: 200, marginLeft: 108},
    codigo_gestion: {display: 'inline-block', width: 200, marginLeft: 8},
}));

const UniMedShow = props => {
    const classes = useStyles();
    const { permissions } = usePermissions();
    var w_role_auxiliar_editar = ''
    var w_permissions_admuno_auxiliar_editar = permissions
    if(w_permissions_admuno_auxiliar_editar==null){}else{
        var wa_role_auxiliar_editar = w_permissions_admuno_auxiliar_editar.indexOf('ROLE_AUXILIAR_EDITAR')
        if(wa_role_auxiliar_editar===-1){}else{
            w_role_auxiliar_editar = 'ROLE_AUXILIAR_EDITAR'
        }
    }
    const [UniMed, setUniMed] = useState('');
    const [PersonaTipo, setPersonaTipo] = useState('');
    // const [UniMedSocioUniMedCasado, setUniMedSocioUniMedCasado] = useState('');

    const establecerUniMed = value => {
        if (value == null || value === '') return '';
        setUniMed(value.trim());
        return value;
    };

    const establecerFecha = value => {
        if (value == null || value === '') return '';
        return value;
    };

    // Obtengo tipo de persona para cargar solapa correspondiente
    const establecerPersonaTipo = value => {
        if (value == null || value === '') return '';
        setPersonaTipo(value.trim());
        return value;
    };


    const cuitCuilFormat = value => {
        if (value == null || value === '') return '';

        //normalize string and remove all unnecessary characters
        var valueCuit = value.replace(/[^\d]/g, "");

        //check if number length equals to 11
        if (valueCuit.length == 11) {
            return value.replace(/(\d{2})(\d{8})(\d{1})/, "$1-$2-$3");
        }

        return value
    };

    // const establecerUniMedSocioUniMedCasado = value => {
    //     if (value == null || value === '') return '';
    //     setUniMedSocioUniMedCasado(value.trim());
    //     return value;
    // };

    const PostEditActions = ({basePath, data, resource}) => (
        <TopToolbar>
            {w_role_auxiliar_editar === 'ROLE_AUXILIAR_EDITAR' &&
                <EditButton basePath={basePath} record={data}/>
            }
        </TopToolbar>
    );

    const PostTitle = ({record}) => {
        return <span>Unidad Medida: {record ? `${record.unidad_medida_d}` : ''}</span>;
    };

    return (
        <Show title={<PostTitle/>} actions={<PostEditActions/>} {...props}>
            <TabbedForm toolbar={false}>
                <FormTab label="DATOS UNIDAD MEDIDA">
                    <TextInput
                        label="Código Unidad Medida"
                        source="unidad_medida"
                        formClassName={classes.unidad_medida}
                        placeholder="Ingrese Código Unidad Medida"
                        helperText="Código Unidad Medida"
                        margin="normal"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        inputProps={{readOnly: true}}
                    />

                    <TextInput
                        label="Descripción Unidad Medida"
                        source="unidad_medida_d"
                        formClassName={classes.unidad_medida_d}
                        placeholder="Ingrese Descripción Unidad Medida"
                        helperText="Descripción Unidad Medida"
                        margin="normal"
                        fullWidth={true}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        inputProps={{readOnly: true}}
                    />

                    <br/>

                    <TextInput
                        label="Unidad Medida Abre."
                        source="unidad_medida_abre"
                        formClassName={classes.unidad_medida_abre}
                        placeholder="Ingrese Unidad Medida Abre."
                        helperText="Unidad Medida Abre."
                        margin="normal"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        inputProps={{readOnly: true}}
                    />

                    <TextInput
                        label="Código AFIP"
                        source="codigo_afip"
                        formClassName={classes.codigo_afip}
                        placeholder="Ingrese Código AFIP"
                        helperText="Código AFIP"
                        margin="normal"
                        fullWidth={true}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        inputProps={{readOnly: true}}
                    />


                    <TextInput
                        label="Código Gestion"
                        source="codigo_gestion"
                        formClassName={classes.codigo_gestion}
                        placeholder="Ingrese Código Gestion"
                        helperText="Código Gestion"
                        margin="normal"
                        fullWidth={true}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        inputProps={{readOnly: true}}
                    />


                </FormTab>
            </TabbedForm>
        </Show>
    )
};
export default UniMedShow;


